import { useOutletContext } from 'react-router'
import { ButtonLinkLegacy } from '@/components/ui/button-link-legacy'
import { Container } from '@/components/ui/container'
import { ClockIcon, ImageCheckIcon } from '@/components/ui/icons'
import { Spinner } from '@/components/ui/spinner'
import { PhotosetStatusMessage } from '@/features/photoset/components/photoset-status-message/photoset-status-message'
import { useGetPhotoset } from '@/features/photoset/queries/use-get-photoset'
import type { PhotosetURLParams } from '@/features/photoset/types'
import { useTranslation } from '@/translations/i18n'

export const PhotosetInitialQaStepV1 = () => {
	const { t } = useTranslation()
	const { urlParams } = useOutletContext<{ urlParams: PhotosetURLParams }>()
	const photosetQuery = useGetPhotoset(
		{
			id: urlParams.id
		},
		{ enabled: false }
	)

	return (
		<Container className='flex flex-col items-center justify-center'>
			{photosetQuery.isFetching ? (
				<Spinner className='fill-neutral-500' size={48} />
			) : (
				<>
					{photosetQuery.data?.zip_url ? (
						<ImageCheckIcon
							className='fill-neutral-900'
							height={48}
							width={48}
						/>
					) : (
						<ClockIcon
							className='fill-neutral-900'
							height={48}
							width={48}
						/>
					)}

					<PhotosetStatusMessage>
						<h1 className='font-bold text-display-xs text-neutral-900'>
							{t('photoset:temporary_initial_qa.title')}
						</h1>
						<p className='text-neutral-900 text-xl'>
							{photosetQuery.data?.zip_url
								? t('photoset:temporary_initial_qa.paragraph')
								: t(
										'photoset:temporary_initial_qa.wait_paragraph'
									)}
						</p>
					</PhotosetStatusMessage>

					{photosetQuery.data?.zip_url && (
						<ButtonLinkLegacy
							size='lg'
							target='_blank'
							to={photosetQuery.data.zip_url}
						>
							{t('common:download_zip')}
						</ButtonLinkLegacy>
					)}
				</>
			)}
		</Container>
	)
}

PhotosetInitialQaStepV1.displayName = 'PhotosetInitialQaStepV1'
